<wiz-vgroup
  width="100%"
  height="100%"
  horizontalAlign="center"
  gap="2"
  class="tile-shadow"
  [wizDisabled]="owner.wizDisabled">
  <wiz-hgroup
    width="100%"
    height="30px"
    verticalAlign="center"
    padding="3px"
    gap="2"
    class="tile-header">
    <wiz-icon #iconAdd [wizTooltip]="'$.vision.measure.add.$'" (click)="doAdd($event)">add</wiz-icon>
    <wiz-label
      #lbTitle class="thumbLabel"
      width="100%"
      [wizLabel]="currentLabel"
      [wizTextBehavior]="'truncate'"
      [class.error-class]="hasError()"></wiz-label>

  </wiz-hgroup>
  <wiz-group
    width="100%"
    height="100%"
    class="tile-body"
    verticalAlign="center"
    horizontalAlign="center"
  >
    <wiz-label
      #lbContent
      [wizLabel]="currentFormula"
      width="100%"
      padding="3px"
      [wizNbLine]="3"
      [wizTextBehavior]="'wordWrap'"
    ></wiz-label>
  </wiz-group>
</wiz-vgroup>
